/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './search-results.component';
import * as import1 from '@angular/core/src/change_detection/change_detection';
import * as import2 from '@angular/core/src/linker/view_utils';
import * as import3 from '@angular/core/src/linker/view';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/linker/element';
import * as import6 from '@angular/core/src/di/injector';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '../shared/config.service';
import * as import9 from '../shared/content.service';
import * as import10 from '../shared/utils.service';
import * as import11 from '@angular/router/src/router';
import * as import12 from '@angular/router/src/router_state';
import * as import13 from '@angular/core/src/metadata/view';
import * as import14 from '@angular/core/src/linker/component_factory';
import * as import15 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import16 from '../shared/truncate.pipe';
import * as import17 from '@angular/core/src/linker/template_ref';
import * as import18 from '@angular/common/src/directives/ng_if';
import * as import19 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import20 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import21 from '@angular/common/src/directives/ng_for';
import * as import22 from '../../../node_modules/@angular/forms/src/directives/checkbox_value_accessor.ngfactory';
import * as import23 from '../../../node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import24 from '../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import25 from '@angular/core/src/linker/element_ref';
import * as import26 from '@angular/forms/src/directives/checkbox_value_accessor';
import * as import27 from '@angular/forms/src/directives/control_value_accessor';
import * as import28 from '@angular/forms/src/directives/ng_model';
import * as import29 from '@angular/forms/src/directives/ng_control';
import * as import30 from '@angular/forms/src/directives/ng_control_status';
import * as import31 from '@angular/core/src/security';
import * as import32 from '../../../node_modules/ng2-bs-pagination/src/pagination.component.ngfactory';
import * as import33 from 'ng2-bs-pagination/src/pagination.component';
export class Wrapper_SearchResultsComponent {
  context:import0.SearchResultsComponent;
  changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any) {
    this.changed = false;
    this.context = new import0.SearchResultsComponent(p0,p1,p2,p3,p4);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
  }
  check_esContents(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this.changed = true;
      this.context.esContents = currValue;
      this._expr_0 = currValue;
    }
  }
  check_dbContents(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this.changed = true;
      this.context.dbContents = currValue;
      this._expr_1 = currValue;
    }
  }
  check_pageSize(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this.changed = true;
      this.context.pageSize = currValue;
      this._expr_2 = currValue;
    }
  }
  detectChangesInInputProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_SearchResultsComponent_Host:import4.RenderComponentType = (null as any);
class _View_SearchResultsComponent_Host0 extends import3.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import5.AppElement;
  _SearchResultsComponent_0_4:Wrapper_SearchResultsComponent;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchResultsComponent_Host0,renderType_SearchResultsComponent_Host,import7.ViewType.HOST,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer,'admin-search-results',import2.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import5.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_SearchResultsComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._SearchResultsComponent_0_4 = new Wrapper_SearchResultsComponent(this.parentInjector.get(import8.ConfigService),this.parentInjector.get(import9.ContentService),this.parentInjector.get(import10.UtilsService),this.parentInjector.get(import11.Router),this.parentInjector.get(import12.ActivatedRoute));
    this._appEl_0.initComponent(this._SearchResultsComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._SearchResultsComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.SearchResultsComponent) && (0 === requestNodeIndex))) { return this._SearchResultsComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._SearchResultsComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    if (!throwOnChange) { this._SearchResultsComponent_0_4.context.ngAfterContentChecked(); }
    this._SearchResultsComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchResultsComponent_Host0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  if ((renderType_SearchResultsComponent_Host === (null as any))) { (renderType_SearchResultsComponent_Host = viewUtils.createRenderComponentType('',0,import13.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_SearchResultsComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const SearchResultsComponentNgFactory:import14.ComponentFactory<import0.SearchResultsComponent> = new import14.ComponentFactory<import0.SearchResultsComponent>('admin-search-results',viewFactory_SearchResultsComponent_Host0,import0.SearchResultsComponent);
const styles_SearchResultsComponent:any[] = ([] as any[]);
var renderType_SearchResultsComponent:import4.RenderComponentType = (null as any);
class _View_SearchResultsComponent0 extends import3.AppView<import0.SearchResultsComponent> {
  _text_0:any;
  _anchor_1:any;
  /*private*/ _appEl_1:import5.AppElement;
  _TemplateRef_1_5:any;
  _NgIf_1_6:import15.Wrapper_NgIf;
  _text_2:any;
  _anchor_3:any;
  /*private*/ _appEl_3:import5.AppElement;
  _TemplateRef_3_5:any;
  _NgIf_3_6:import15.Wrapper_NgIf;
  _pipe_truncate_0:import16.TruncatePipe;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchResultsComponent0,renderType_SearchResultsComponent,import7.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._text_0 = this.renderer.createText(parentRenderNode,'  ',(null as any));
    this._anchor_1 = this.renderer.createTemplateAnchor(parentRenderNode,(null as any));
    this._appEl_1 = new import5.AppElement(1,(null as any),this,this._anchor_1);
    this._TemplateRef_1_5 = new import17.TemplateRef_(this._appEl_1,viewFactory_SearchResultsComponent1);
    this._NgIf_1_6 = new import15.Wrapper_NgIf(this._appEl_1.vcRef,this._TemplateRef_1_5);
    this._text_2 = this.renderer.createText(parentRenderNode,'\n  ',(null as any));
    this._anchor_3 = this.renderer.createTemplateAnchor(parentRenderNode,(null as any));
    this._appEl_3 = new import5.AppElement(3,(null as any),this,this._anchor_3);
    this._TemplateRef_3_5 = new import17.TemplateRef_(this._appEl_3,viewFactory_SearchResultsComponent5);
    this._NgIf_3_6 = new import15.Wrapper_NgIf(this._appEl_3.vcRef,this._TemplateRef_3_5);
    this._pipe_truncate_0 = new import16.TruncatePipe();
    this.init(([] as any[]),[
      this._text_0,
      this._anchor_1,
      this._text_2,
      this._anchor_3
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import17.TemplateRef) && (1 === requestNodeIndex))) { return this._TemplateRef_1_5; }
    if (((token === import18.NgIf) && (1 === requestNodeIndex))) { return this._NgIf_1_6.context; }
    if (((token === import17.TemplateRef) && (3 === requestNodeIndex))) { return this._TemplateRef_3_5; }
    if (((token === import18.NgIf) && (3 === requestNodeIndex))) { return this._NgIf_3_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_1_0_0:any = this.context.dbContents;
    this._NgIf_1_6.check_ngIf(currVal_1_0_0,throwOnChange,false);
    this._NgIf_1_6.detectChangesInInputProps(this,this._anchor_1,throwOnChange);
    const currVal_3_0_0:any = this.context.dbContents;
    this._NgIf_3_6.check_ngIf(currVal_3_0_0,throwOnChange,false);
    this._NgIf_3_6.detectChangesInInputProps(this,this._anchor_3,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
export function viewFactory_SearchResultsComponent0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<import0.SearchResultsComponent> {
  if ((renderType_SearchResultsComponent === (null as any))) { (renderType_SearchResultsComponent = viewUtils.createRenderComponentType('',0,import13.ViewEncapsulation.None,styles_SearchResultsComponent,{})); }
  return new _View_SearchResultsComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_SearchResultsComponent1 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _appEl_2:import5.AppElement;
  _TemplateRef_2_5:any;
  _NgFor_2_6:import19.Wrapper_NgFor;
  _text_3:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchResultsComponent1,renderType_SearchResultsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'div',new import2.InlineArray2(2,'class','row row-eq-height'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_2 = new import5.AppElement(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import17.TemplateRef_(this._appEl_2,viewFactory_SearchResultsComponent2);
    this._NgFor_2_6 = new import19.Wrapper_NgFor(this._appEl_2.vcRef,this._TemplateRef_2_5,this.parentInjector.get(import20.IterableDiffers),this.parent.ref);
    this._text_3 = this.renderer.createText(this._el_0,'\n  ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import17.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import21.NgFor) && (2 === requestNodeIndex))) { return this._NgFor_2_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parent.context.dbContents;
    this._NgFor_2_6.check_ngForOf(currVal_2_0_0,throwOnChange,false);
    this._NgFor_2_6.detectChangesInInputProps(this,this._anchor_2,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchResultsComponent1(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchResultsComponent1(viewUtils,parentInjector,declarationEl);
}
class _View_SearchResultsComponent2 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _text_2:any;
  _anchor_3:any;
  /*private*/ _appEl_3:import5.AppElement;
  _TemplateRef_3_5:any;
  _NgIf_3_6:import15.Wrapper_NgIf;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _appEl_5:import5.AppElement;
  _TemplateRef_5_5:any;
  _NgIf_5_6:import15.Wrapper_NgIf;
  _text_6:any;
  _text_7:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchResultsComponent2,renderType_SearchResultsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'div',new import2.InlineArray2(2,'class','col-sm-6 col-md-4 col-lg-3'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._text_2 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._anchor_3 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_3 = new import5.AppElement(3,0,this,this._anchor_3);
    this._TemplateRef_3_5 = new import17.TemplateRef_(this._appEl_3,viewFactory_SearchResultsComponent3);
    this._NgIf_3_6 = new import15.Wrapper_NgIf(this._appEl_3.vcRef,this._TemplateRef_3_5);
    this._text_4 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_5 = new import5.AppElement(5,0,this,this._anchor_5);
    this._TemplateRef_5_5 = new import17.TemplateRef_(this._appEl_5,viewFactory_SearchResultsComponent4);
    this._NgIf_5_6 = new import15.Wrapper_NgIf(this._appEl_5.vcRef,this._TemplateRef_5_5);
    this._text_6 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._text_2,
      this._anchor_3,
      this._text_4,
      this._anchor_5,
      this._text_6,
      this._text_7
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import17.TemplateRef) && (3 === requestNodeIndex))) { return this._TemplateRef_3_5; }
    if (((token === import18.NgIf) && (3 === requestNodeIndex))) { return this._NgIf_3_6.context; }
    if (((token === import17.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import18.NgIf) && (5 === requestNodeIndex))) { return this._NgIf_5_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_3_0_0:any = this.context.$implicit;
    this._NgIf_3_6.check_ngIf(currVal_3_0_0,throwOnChange,false);
    this._NgIf_3_6.detectChangesInInputProps(this,this._anchor_3,throwOnChange);
    const currVal_5_0_0:any = this.context.$implicit;
    this._NgIf_5_6.check_ngIf(currVal_5_0_0,throwOnChange,false);
    this._NgIf_5_6.detectChangesInInputProps(this,this._anchor_5,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_SearchResultsComponent2(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchResultsComponent2(viewUtils,parentInjector,declarationEl);
}
class _View_SearchResultsComponent3 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _CheckboxControlValueAccessor_6_3:import22.Wrapper_CheckboxControlValueAccessor;
  _NG_VALUE_ACCESSOR_6_4:any[];
  _NgModel_6_5:import23.Wrapper_NgModel;
  _NgControl_6_6:any;
  _NgControlStatus_6_7:import24.Wrapper_NgControlStatus;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  /*private*/ _expr_16:any;
  /*private*/ _expr_17:any;
  /*private*/ _expr_18:any;
  /*private*/ _expr_19:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchResultsComponent3,renderType_SearchResultsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_16 = import1.UNINITIALIZED;
    this._expr_17 = import1.UNINITIALIZED;
    this._expr_18 = import1.UNINITIALIZED;
    this._expr_19 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'div',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'img',new import2.InlineArray2(2,'class','fa fa-edit img-responsive'),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    this._el_4 = import2.createRenderElement(this.renderer,this._el_0,'span',new import2.InlineArray2(2,'class','image-tag switch material-switch'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n              ',(null as any));
    this._el_6 = import2.createRenderElement(this.renderer,this._el_4,'input',new import2.InlineArray2(2,'type','checkbox'),(null as any));
    this._CheckboxControlValueAccessor_6_3 = new import22.Wrapper_CheckboxControlValueAccessor(this.renderer,new import25.ElementRef(this._el_6));
    this._NG_VALUE_ACCESSOR_6_4 = [this._CheckboxControlValueAccessor_6_3.context];
    this._NgModel_6_5 = new import23.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_6_4);
    this._NgControl_6_6 = this._NgModel_6_5.context;
    this._NgControlStatus_6_7 = new import24.Wrapper_NgControlStatus(this._NgControl_6_6);
    this._text_7 = this.renderer.createText(this._el_4,'\n              ',(null as any));
    this._el_8 = import2.createRenderElement(this.renderer,this._el_4,'label',new import2.InlineArray2(2,'class','label-primary'),(null as any));
    this._text_9 = this.renderer.createText(this._el_4,'\n          ',(null as any));
    this._text_10 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_6,'click',this.eventHandler(this._handle_click_6_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_6,'ngModelChange',this.eventHandler(this._handle_ngModelChange_6_1.bind(this)));
    var disposable_2:Function = this.renderer.listen(this._el_6,'change',this.eventHandler(this._handle_change_6_2.bind(this)));
    var disposable_3:Function = this.renderer.listen(this._el_6,'blur',this.eventHandler(this._handle_blur_6_3.bind(this)));
    const subscription_0:any = this._NgModel_6_5.context.update.subscribe(this.eventHandler(this._handle_ngModelChange_6_1.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3
    ]
    ,[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import26.CheckboxControlValueAccessor) && (6 === requestNodeIndex))) { return this._CheckboxControlValueAccessor_6_3.context; }
    if (((token === import27.NG_VALUE_ACCESSOR) && (6 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_6_4; }
    if (((token === import28.NgModel) && (6 === requestNodeIndex))) { return this._NgModel_6_5.context; }
    if (((token === import29.NgControl) && (6 === requestNodeIndex))) { return this._NgControl_6_6; }
    if (((token === import30.NgControlStatus) && (6 === requestNodeIndex))) { return this._NgControlStatus_6_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._CheckboxControlValueAccessor_6_3.detectChangesInInputProps(this,this._el_6,throwOnChange);
    const currVal_6_1_0:any = import2.interpolate(1,'',this.parent.context.$implicit._id,'');
    this._NgModel_6_5.check_name(currVal_6_1_0,throwOnChange,false);
    const currVal_6_1_1:any = this.parent.context.$implicit.active;
    this._NgModel_6_5.check_model(currVal_6_1_1,throwOnChange,false);
    this._NgModel_6_5.detectChangesInInputProps(this,this._el_6,throwOnChange);
    this._NgControlStatus_6_7.detectChangesInInputProps(this,this._el_6,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_16:any = import2.interpolate(1,'/data/covers/thumbs/',this.parent.context.$implicit.cover.front,'');
    if (import2.checkBinding(throwOnChange,this._expr_16,currVal_16)) {
      this.renderer.setElementProperty(this._el_2,'src',this.viewUtils.sanitizer.sanitize(import31.SecurityContext.URL,currVal_16));
      this._expr_16 = currVal_16;
    }
    const currVal_17:any = import2.interpolate(1,'',this.parent.context.$implicit.cover.front,'');
    if (import2.checkBinding(throwOnChange,this._expr_17,currVal_17)) {
      this.renderer.setElementProperty(this._el_2,'alt',currVal_17);
      this._expr_17 = currVal_17;
    }
    const currVal_18:any = import2.interpolate(1,'',this.parent.context.$implicit._id,'');
    if (import2.checkBinding(throwOnChange,this._expr_18,currVal_18)) {
      this.renderer.setElementProperty(this._el_6,'id',currVal_18);
      this._expr_18 = currVal_18;
    }
    this._CheckboxControlValueAccessor_6_3.detectChangesInHostProps(this,this._el_6,throwOnChange);
    this._NgModel_6_5.detectChangesInHostProps(this,this._el_6,throwOnChange);
    this._NgControlStatus_6_7.detectChangesInHostProps(this,this._el_6,throwOnChange);
    const currVal_19:any = import2.interpolate(1,'',this.parent.context.$implicit._id,'');
    if (import2.checkBinding(throwOnChange,this._expr_19,currVal_19)) {
      this.renderer.setElementAttribute(this._el_8,'for',((currVal_19 == (null as any))? (null as any): currVal_19.toString()));
      this._expr_19 = currVal_19;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._NgModel_6_5.context.ngOnDestroy();
  }
  private _handle_click_6_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_6_0:any = ((<any>this.parent.parent.parent.context.onStatusChange(!this.parent.context.$implicit.active,this.parent.context.$implicit)) !== false);
    return (true && pd_6_0);
  }
  private _handle_ngModelChange_6_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_6_0:any = ((<any>(this.parent.context.$implicit.active = $event)) !== false);
    return (true && pd_6_0);
  }
  private _handle_change_6_2($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_6_0:any = ((<any>this._CheckboxControlValueAccessor_6_3.context.onChange($event.target.checked)) !== false);
    return (true && pd_6_0);
  }
  private _handle_blur_6_3($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_6_0:any = ((<any>this._CheckboxControlValueAccessor_6_3.context.onTouched()) !== false);
    return (true && pd_6_0);
  }
}
function viewFactory_SearchResultsComponent3(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchResultsComponent3(viewUtils,parentInjector,declarationEl);
}
class _View_SearchResultsComponent4 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  /*private*/ _expr_5:any;
  _pipe_truncate_0_0:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchResultsComponent4,renderType_SearchResultsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_5 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'div',new import2.InlineArray2(2,'class','lLink thumb-title'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'a',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_2,'click',this.eventHandler(this._handle_click_2_0.bind(this)));
    this._pipe_truncate_0_0 = import2.pureProxy2((<_View_SearchResultsComponent0>this.parent.parent.parent)._pipe_truncate_0.transform.bind((<_View_SearchResultsComponent0>this.parent.parent.parent)._pipe_truncate_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_5:any = import2.interpolate(1,'',valUnwrapper.unwrap(import2.castByValue(this._pipe_truncate_0_0,(<_View_SearchResultsComponent0>this.parent.parent.parent)._pipe_truncate_0.transform)(this.parent.context.$implicit.title,'80')),'');
    if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange,this._expr_5,currVal_5))) {
      this.renderer.setText(this._text_3,currVal_5);
      this._expr_5 = currVal_5;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_2_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_2_0:any = ((<any>this.parent.parent.parent.context.router.navigate([('record/edit/' + this.parent.context.$implicit._id)],{relativeTo: this.parent.parent.parent.context.route.parent})) !== false);
    return (true && pd_2_0);
  }
}
function viewFactory_SearchResultsComponent4(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchResultsComponent4(viewUtils,parentInjector,declarationEl);
}
class _View_SearchResultsComponent5 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  /*private*/ _appEl_2:import5.AppElement;
  _PaginationComponent_2_4:import32.Wrapper_PaginationComponent;
  _text_3:any;
  _text_4:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_SearchResultsComponent5,renderType_SearchResultsComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'div',new import2.InlineArray2(2,'style','text-align: center'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'ng-pagination',new import2.InlineArray16(10,'first-text','First','last-text','Last','next-text','›','previous-text','‹','style','cursor: pointer'),(null as any));
    this._appEl_2 = new import5.AppElement(2,0,this,this._el_2);
    var compView_2:any = import32.viewFactory_PaginationComponent0(this.viewUtils,this.injector(2),this._appEl_2);
    this._PaginationComponent_2_4 = new import32.Wrapper_PaginationComponent();
    this._appEl_2.initComponent(this._PaginationComponent_2_4.context,([] as any[]),compView_2);
    this._text_3 = this.renderer.createText((null as any),'\n    ',(null as any));
    compView_2.create(this._PaginationComponent_2_4.context,([] as any[]),(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n  ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_2,'pageChange',this.eventHandler(this._handle_pageChange_2_0.bind(this)));
    const subscription_0:any = this._PaginationComponent_2_4.context.pageChange.subscribe(this.eventHandler(this._handle_pageChange_2_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ,[disposable_0],[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import33.PaginationComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._PaginationComponent_2_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = '‹';
    this._PaginationComponent_2_4.check_previousText(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = '›';
    this._PaginationComponent_2_4.check_nextText(currVal_2_0_1,throwOnChange,false);
    const currVal_2_0_2:any = 'First';
    this._PaginationComponent_2_4.check_firstText(currVal_2_0_2,throwOnChange,false);
    const currVal_2_0_3:any = 'Last';
    this._PaginationComponent_2_4.check_lastText(currVal_2_0_3,throwOnChange,false);
    const currVal_2_0_4:any = this.parent.context.esContents.total;
    this._PaginationComponent_2_4.check_totalItems(currVal_2_0_4,throwOnChange,false);
    const currVal_2_0_5:any = this.parent.context.currentPage;
    this._PaginationComponent_2_4.check_currentPage(currVal_2_0_5,throwOnChange,false);
    const currVal_2_0_6:any = this.parent.context.pageSize;
    this._PaginationComponent_2_4.check_pageSize(currVal_2_0_6,throwOnChange,false);
    this._PaginationComponent_2_4.detectChangesInInputProps(this,this._el_2,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._PaginationComponent_2_4.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_pageChange_2_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_2_0:any = ((<any>this.parent.context.onPageChange($event)) !== false);
    return (true && pd_2_0);
  }
}
function viewFactory_SearchResultsComponent5(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_SearchResultsComponent5(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/search-results.component.ngfactory.ts